import { render, staticRenderFns } from "./credible_title.vue?vue&type=template&id=806d09de&scoped=true"
import script from "./credible_title.vue?vue&type=script&lang=js"
export * from "./credible_title.vue?vue&type=script&lang=js"
import style0 from "./credible_title.vue?vue&type=style&index=0&id=806d09de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806d09de",
  null
  
)

export default component.exports